<template>
  <div class="my-content">
    <div class="my-content-head">
      <div class="person-img">
        <img src="../assets/image/person-icon.png" />
      </div>
      <div class="person-info" @click="toPerson">
        <div class="person-name">{{ student.name }}</div>
        <div class="person-phone"> {{ student.phone }}</div>
      </div>
      <div class="person-edit-btn"><i class="el-icon-arrow-right"></i></div>
    </div>
    <div class="my-content-order">
      <div class="order-title">
        <div class="title-each">我的订单</div>
      </div>
      <div class="orderList-type">
        <van-grid :column-num="3" :border=false class="order-grid">
          <van-grid-item v-for="(item, value) in orderList" :key="value" class="grid-item" @click="toMyOrder(value)">
            <template v-if="value === 0">
              <img src='../assets/image/order-all-icon.png' class="order-img" />
            </template>
            <template v-if="value === 1">
              <img src='../assets/image/order-wait-icon.png' class="order-img" />
            </template>
            <template v-if="value === 2">
              <img src='../assets/image/order-pay-icon.png' class="order-img" />
            </template>
            <div class="order-text">{{ item.name }}</div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <div class="my-content-profit" @click="toCashback()">
      <div class="title-each">分销收益</div>
      <div class="right-btn"><i class="el-icon-arrow-right"></i></div>
    </div>
    <div class="my-content-teach" @click="toPaidTeach()">
      <div class="title-each">已购课程</div>
      <div class="right-btn"><i class="el-icon-arrow-right"></i></div>
    </div>
    <div class="logOut-btn" @click="showConfirm">切换账号</div>
  </div>
</template>

<script>
import { getLoginInfo, logout } from '@/api/common'   //路径
import { showConfirmDialog } from 'vant';
export default {
  name: 'MyPage',
  props: {
    data: {
      type: Object
    },
  },
  data() {
    return {
      merchantId: '',
      student: {
        name: '',
        phone: ''
      },
      orderList: [
        {
          image: '../assets/image/home-type-icon.png',
          name: '全部订单'
        },
        {
          image: '../assets/image/home-type-icon.png',
          name: '未完成'
        },
        {
          image: '../assets/image/home-type-icon.png',
          name: '已完成'
        },
      ]
    }
  },
  mounted() {
    this.merchantId = this.data.merchantId;
    this.getPersonInfo();
  },
  methods: {
    getPersonInfo() {
      let params = {};
      getLoginInfo(params).then((res) => {
        if (res.code === 200) {
          this.student = res.student;
          localStorage.setItem('loginInfo', JSON.stringify(res.student));
        }
      })
    },
    showConfirm() {
      let that = this;
      showConfirmDialog({
        title: '',
        message:
          '是否退出此账号',
      })
        .then(() => {
          // on confirm
          that.logoutPage();
        })
        .catch(() => {
          // on cancel
        });
    },
    logoutPage() {
      let that = this;
      let params = {};
      logout(params).then((res) => {
        if (res.code !== 200) {
          that.$message.error(res.msg);
        } else {
          localStorage.removeItem('loginToken' + that.merchantId);
          localStorage.removeItem('loginInfo');
          localStorage.removeItem('activeName');
          localStorage.removeItem('examResult');
          that.$message({
            duration: 1000,
            message: '退出成功',//提示的信息
            type: 'success',//类型是成功
            onClose: () => {
              that.$router.push({ name: 'login', params: { id: that.merchantId } });
            }
          });
        }
      })
    },
    toPerson() {
      this.$router.push({ name: 'person', params: { id: this.merchantId } });
    },
    toMyOrder(index) {
      this.$router.push({ path: '/myOrder/' + this.merchantId, query: { 
        pageShow: index
      }});
    },
    toPaidTeach() {
      this.$router.push({ path: '/paidTeach/' + this.merchantId});
    },
    toCashback() {
      this.$router.push({ path: '/cashback/' + this.merchantId});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  overflow: hidden;
  background-color: #fafafa;
}

.my-content-head {
  padding: 15px 22px 20px 22px;
  display: flex;
  align-items: center;
  height: 52px;
}

.person-img {
  margin-right: 15px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #F8F7F8;
  border: 2px solid #FFFFFF;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.10);
}

.person-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.person-info {
  flex: 1;
  text-align: left
}

.person-edit-btn {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.person-name {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
  font-weight: 600;
}

.person-name span {
  margin-left: 10px;
  padding: 1px 9px;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  color: #F11515;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  background: #FFFFFF;
  border: 1px solid #F11515;
  border-radius: 9px;
}

.person-phone {
  display: inline-block;
  padding: 1px 8px;
  margin-top: 5px;
  font-family: PingFangSC-Semibold;
  font-size: 10px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: left;
  font-weight: 600;
  background: #BBBBBB;
  border-radius: 8px;
}

.my-content-order {
  padding: 15px;
  margin-bottom: 5px;
  background-color: #fff;
}

.order-title {
  display: flex;
}

.my-content-profit {
  padding: 15px;
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.my-content-teach {
  padding: 15px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.logOut-btn {
  padding: 15px;
  font-family: PingFangSC-Regular;
  text-align: center;
  font-size: 14px;
  color: #F11515;
  letter-spacing: 0;
  font-weight: 400;
  background-color: #fff;
}

.title-each {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  font-weight: 500;
}

.right-btn {
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.orderList-type {
  margin-top: 20px;
}

.order-img {
  margin-bottom: 12px;
  width: 24px;
  height: 24px;
  object-fit: cover;
}

.order-text {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}

.grid-item {
  padding: 0 !important;
  height: 71px;
}

.home-type-grid {
  padding: 0 !important;
}

::v-deep .van-grid-item__content {
  padding: 0 !important;
}
</style>